/**
 * Dopyt na tovar dostupný na vyžiadanie.
 *
 * Obsah modalu sa načítava tu (nie cez ModalHelper::remoteContent), prefetch pri hoveri nad tlačidlom - ako product-detail-modal
 *
 * LNS-1604
 */
const $ = window.jQuery;

const TRIGGER_SELECTOR = ".js-product-request-btn";
const MODAL_ID = "product-request-modal";
const PREFETCH_DELAY = 100;

const prefetchCache = new Map();

const fetchContent = (url) =>
    fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } }).then((res) => {
        if (!res.ok) {
            throw new Error(`Failed to load product request form: ${res.status}`);
        }

        return res.text();
    });

const prefetch = (url) => {
    if (!url || prefetchCache.has(url)) {
        return;
    }

    prefetchCache.set(
        url,
        fetchContent(url).catch(() => {
            prefetchCache.delete(url);
        })
    );
};

const initForm = ($modal) => {
    const $form = $modal.find(".js-product-request-form");
    const $error = $modal.find(".js-product-request-error");
    const $success = $modal.find(".js-product-request-success");
    const $submit = $modal.find(".js-product-request-submit");

    $form.validate({
        submitHandler: function (form) {
            $submit.prop("disabled", true).addClass("is-loading");
            $error.slideUp(100);

            Form.ajaxPost(
                form,
                function (data) {
                    $submit.prop("disabled", false).removeClass("is-loading");

                    if (!data.status) {
                        $error.html(data.message).slideDown(200);

                        return;
                    }

                    $modal.find(".js-product-request-hide").slideUp(200);
                    $success.html(data.message).slideDown(200);
                },
                "json"
            );
        },
    });
};

const loadModal = async ($modal, url) => {
    const $content = $modal.find(".modal-content");

    try {
        const html = await (prefetchCache.get(url) ?? fetchContent(url));

        // prefetch mohol medzitým zlyhať a zmazať sa z cache
        if (typeof html !== "string") {
            throw new Error("Empty product request form response");
        }

        $content.html(html);
        $modal.addClass("is-loaded");
        initForm($modal);
    } catch (e) {
        prefetchCache.delete(url);
        $modal.modal("hide");
        window.location.href = url;
    }
};

$(document)
    .on("mouseenter", TRIGGER_SELECTOR, function () {
        const url = $(this).data("href");

        this._productRequestTimer = setTimeout(() => prefetch(url), PREFETCH_DELAY);
    })
    .on("mouseleave", TRIGGER_SELECTOR, function () {
        clearTimeout(this._productRequestTimer);
    })
    .on("touchstart", TRIGGER_SELECTOR, function () {
        prefetch($(this).data("href"));
    });

$(document).on("show.bs.modal", `#${MODAL_ID}`, function (event) {
    const $modal = $(this);
    const url = $(event.relatedTarget).data("href");

    if (!url) {
        return;
    }

    $modal.removeClass("is-loaded").find(".modal-content").html("");
    loadModal($modal, url);
});

$(document).on("hidden.bs.modal", `#${MODAL_ID}`, function () {
    $(this).removeClass("is-loaded").find(".modal-content").html("");
});
